import { useParams } from 'react-router-dom'; 
import PaymentConfigList from './PaymentConfigList';
import PaymentRulesConfig from './PaymentRulesConfig';
import { CircularProgress, Box } from '@mui/material';
import { useGetAssetByIdQuery } from '@/services/assetApi';

export default function PaymentConfigWrapper() {
  const { assetId = '' } = useParams<{ assetId: string }>();
  const { data: asset, isLoading} = useGetAssetByIdQuery(assetId);
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" mt={4}>
        <CircularProgress />
      </Box>
    );
  }

  if ((asset as any)?.isUsingDynamicGatewayRouting) {
    return <PaymentRulesConfig />;
  }

  return <PaymentConfigList />;
}
